import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ComponentPropsWithoutRef, useState } from 'react';

type ComplianceFormHelperProps = Omit<
  ComponentPropsWithoutRef<typeof Grid>,
  'children'
>;

export function ComplianceFormHelper(props: ComplianceFormHelperProps) {
  const [closeHelper, setCloseHelper] = useState(false);

  if (closeHelper) {
    return null;
  }

  function onCloseHelper() {
    setCloseHelper(true);
  }

  return (
    <Grid item={true} {...props}>
      <Grid
        container={true}
        direction="row"
        justifyContent="center"
        border={1}
        borderRadius={1}
        padding={2}
        flexWrap="nowrap"
      >
        <Grid
          item={true}
          xs={0.5}
          style={{ textAlign: 'center' }}
          minWidth={40}
        >
          {' '}
          <InfoIcon htmlColor="#080A2D" />
        </Grid>
        <Grid item={true} xs={11}>
          <Typography variant="body1" fontWeight={'500'} color={'primary.main'}>
            Hi, we’re TheGuarantors. We have partnered with your building to
            validate your insurance
          </Typography>
          <Typography variant="body1" color={'primary.main'}>
            Your building requires that all residents purchase renters insurance
            that meets their requirements. Please fill out the information below
            to validate your renters insurance policy. Once we have validated
            your policy we will notify the building so they know you’re covered.
          </Typography>
        </Grid>
        <Grid
          item={true}
          xs={0.5}
          style={{ textAlign: 'center' }}
          minWidth={40}
        >
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={onCloseHelper} />
        </Grid>
      </Grid>
    </Grid>
  );
}
